export default function cropCanvas(canvas,trimHorizontalMargins, trimVerticalMargins){
  //devicePixelRatio fixes retina displays
  trimHorizontalMargins = Math.round(trimHorizontalMargins * window.devicePixelRatio);
  trimVerticalMargins = Math.round(trimVerticalMargins * window.devicePixelRatio);

  // create a temporary canvas sized to the cropped size
  var newCanvas = document.createElement('canvas');
  var newContext = newCanvas.getContext('2d');

  const cropWidth = canvas.width - trimHorizontalMargins * 2;
  const cropHeight = canvas.height - trimVerticalMargins * 2

  newCanvas.width = cropWidth;
  newCanvas.height = cropHeight;

  newContext.drawImage(canvas,
    trimHorizontalMargins,trimVerticalMargins,cropWidth,cropHeight, //source dimensions
    0,0,cropWidth,cropHeight); //dest dimensions

  return newCanvas;
}



// WEBPACK FOOTER //
// ./src/lib/cropCanvas.js